import { css } from '@mds/core';

export const dropdownCSS = css`
	@supports (--foo: 'mds') {
		/* 	###################################################################### */
		/**	Component tokens
		   	Use the design tokens to set these component tokens.
	     */
		:host {
			--pos-top: 0;
			--pos-left: 0;
			--background-color: var(--mds-color-background-light, white);
			--pad: var(--mds-spacing-4);
		}

		/* 	###################################################################### */
		/**	Dropdown host rules
		  	This is the main rule set.
	  	 */
		.mds-dropdown {
			position: absolute;
			z-index: 9999;
			display: flex;
			flex-direction: column;
			opacity: 1;
			top: var(--pos-top);
			left: var(--pos-left);
			min-width: 20ch;
			max-width: 35ch;
			background-color: var(--background-color);
			padding-inline-start: 0;
			padding-inline-end: 0;
			padding-block-start: 0;
			padding-block-end: var(--mds-spacing-4);

			box-shadow: var(--mds-effects-shadow-base);
		}
		.mds-dropdown[hidden]{
			left: -100vw;
			top: -100vh;
			z-index: -100;
			opacity: 0;
		}
		::slotted(*) {
			display: contents;
		}
		.mds-dropdown-title {
			box-sizing: border-box;
			display: block;
			padding-inline-start: var(--mds-spacing-4);
			padding-inline-end: var(--mds-spacing-4);
			text-align: start;
		}

		:host([data-type=menu]) .mds-dropdown::before {
			content: '';
			position: relative;
			top: -0.5rem;
			left: calc((100% / 2) - 0.5rem);
			width: 1rem;
			height: 1rem;
			background: white;
			transform: rotate(45deg);
		}

		/* Mobile view */

		:host([data-break]) {
			padding: 0;
		}
		:host([data-break]) .mds-dropdown {
			display: flex;
			flex-direction: column;
			position: static;
			max-width: none;
			left: 0;
			box-shadow: none;
			background-color:  var(--mds-color-background-pale);
			padding-inline-start: var(--mds-spacing-6);
			padding-block-start: var(--mds-spacing-2);
			padding-block-end: var(--mds-spacing-2);
		}
		:host([data-break][data-hidden]) .mds-dropdown {
			position: absolute;
			left: -100vw;
		}
		:host([data-break][data-toplevel]) .mds-dropdown {
			display: block;
			position: absolute;
			z-index: 1000;
			top: 65px;
			opacity: 1;
			left: 0;
			width: 100%;
			background-color:  var(--mds-color-background-light);
			transition: left 0.2s ease-in;
			box-shadow: var(--mds-effects-shadow-base);
			padding-inline-start: calc(var(--pad-responsive) - var(--mds-spacing-3));
			padding-block-start: var(--mds-spacing-4);
			padding-block-end: var(--mds-spacing-4);
		}
		:host([data-break][data-hidden][data-toplevel]) .mds-dropdown {
			display: block;
			left: -100vw;
			opacity: 1;
			transition: left 0.2s ease-out;
		}

		:host([data-break]) .mds-dropdown::before  {
			content: none;
		}
		/* 	###################################################################### */
		/**	Properties for Dropdown */

	}
`;
